import { PermissionCode } from '@gb-ticket/shared-types';

import { hasPermission } from '@/platform/auth/permissions';
import { registerProfileSection } from '@/platform/lib/profile-sections';
import { IntranetAcknowledgementsCard } from '@/products/intranet/components/intranet-acknowledgements-card';
import { IntranetActivityCard } from '@/products/intranet/components/intranet-activity-card';

registerProfileSection({
  id: 'intranet.activity',
  navLabel: 'Intranet',
  path: 'intranet',
  Component: IntranetActivityCard,
  isVisible: (user) => hasPermission(user, PermissionCode.INTRANET_CONTENT_READ),
});

registerProfileSection({
  id: 'intranet.acknowledgements',
  navLabel: 'Intranet',
  path: 'intranet',
  Component: IntranetAcknowledgementsCard,
  isVisible: (user) => hasPermission(user, PermissionCode.INTRANET_CONTENT_READ),
});
